import React from 'react';
import SectionHeader from './SectionHeader';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-doc">
      <SectionHeader index="09" label="Sign-off" title="Let's ship something" />

      <div className="contact-body reveal">
        <p className="contact-text">
          I'm looking for teams building high-impact products, places where
          owning the "why" and writing the "how" are the same job. Questions,
          ideas, or just a hello: the inbox is open.
        </p>

        <a href="mailto:tanmayrajurkar1915@gmail.com" className="contact-email">
          tanmayrajurkar1915@gmail.com
          <span className="contact-email-arrow" aria-hidden="true">→</span>
        </a>

        <div className="contact-footline">
          <div className="contact-status">
            <span className="status-dot" aria-hidden="true"></span>
            <span>Currently Building</span>
          </div>
          <span className="stamp contact-stamp">Replies fast</span>
        </div>
      </div>
    </div>
  );
}

export default Contact;
